import styled from 'styled-components';

import { ArticleSection } from 'editorial/components/ArticleSection';
import { IArticleQuoteSection, IArticleSectionAdditionalProps } from 'editorial/types';
import { createSanitizedHtmlObject } from 'shared/utils/createSanitizedHtml';
import { useRouter } from 'next/router';
import { localizeUrl } from 'localization/utils/localizeUrl';

export const ArticleQuote = ({
  quote,
  quoteSource,
}: IArticleQuoteSection & IArticleSectionAdditionalProps) => {
  const { locale } = useRouter();
  return (
    <ArticleSection>
      <ArticleQuote.Block>
        <ArticleQuote.Text
          data-qa="quote_text"
          dangerouslySetInnerHTML={createSanitizedHtmlObject(localizeUrl(quote, locale))}
        />
        <ArticleQuote.Source
          data-qa="quote_source"
          dangerouslySetInnerHTML={createSanitizedHtmlObject(localizeUrl(quoteSource, locale))}
        />
      </ArticleQuote.Block>
    </ArticleSection>
  );
};

ArticleQuote.Block = styled.blockquote`
  padding: 20px 0;
  margin: 0 auto;
  max-width: none;
  text-align: left;
  letter-spacing: -0.5px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    padding: 5em 80px;
  }
`;

ArticleQuote.Text = styled.div`
  p {
    font-size: 28px;
    line-height: 1.33;
    font-weight: 300;

    &:before,
    &:after {
      display: inline-block;
    }
    &:before {
      content: open-quote;
    }
    &:after {
      content: close-quote;
    }

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}px) {
      font-size: 48px;
    }

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
      line-height: 1.2;
    }
  }
`;

ArticleQuote.Source = styled.div`
  p {
    font-size: 11.5px;
    line-height: 1.8;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    text-align: center;
  }
`;
